/// <reference path='./Types/react-svg-inline.d.ts'/>

import ReactDOM from 'react-dom';

import App from '@/Components/App';

ReactDOM.render(<App />, window.app);
